import React, {PureComponent} from "react"
import scrollToElement from 'helpers/scrollToElement';

export class OosActionButtons extends PureComponent {
  constructor (props) {
    super (props);
    this.state = {
      actions : []
    };
  }

  triggerNewrelicEvent (action, name){
    window.newrelic = window.newrelic || undefined;
    const asyncTriggerNewrelicEvent = async (action, name = 'oos-action-button') => {
      if(window.newrelic) window.newrelic.addPageAction(`${name}:${action}`, {});
    }
    asyncTriggerNewrelicEvent(action, name);
  }

  componentDidMount() {

    const actions = [];

    const { emailMeVisible, storeStockVisible } = this.props;
    const recs = [].filter.call(document.getElementsByTagName('jl-recommendations-panel'), el => el.getAttribute('placement') === 'OSPStandardOos');
    const [rec] = recs;

    if (emailMeVisible === 'true') {
      actions.push({name: 'Email me when available', onClick: ()=> this.emailMeWhenAvailable()})
      this.triggerNewrelicEvent('email-me-when-available');
    }

    if (storeStockVisible === 'true') {
      actions.push({name: 'Check in-store stock', onClick: ()=> this.storeStock()})
      this.triggerNewrelicEvent('check-in-store');
    }

    if (rec) {
      actions.push({name: 'See similar', onClick: ()=> this.similarProducts()})
      this.triggerNewrelicEvent('similar-products')
    }

    this.setState({actions})
  }

  emailMeWhenAvailable(){
    const emailMeWhenAvailable = document.querySelector('.product-detail__email-me-container');
    if (emailMeWhenAvailable) scrollToElement(emailMeWhenAvailable);
    this.triggerNewrelicEvent('email-me-when-available-clicked');
  }

  similarProducts(){
    const recs = [].filter.call(document.getElementsByTagName('jl-recommendations-panel'), el => el.getAttribute('placement') === 'OSPStandardOos');
    const [rec] = recs;
    if (rec) scrollToElement(rec);

    this.triggerNewrelicEvent('similar-products-clicked');
  }

  storeStock(){
    const storeStockButton = document.querySelector('#store-stock-button');
    if (storeStockButton) {
      storeStockButton.click();
      const sizeNotSelected = document.querySelector('input[name="sizeNotSelected"]');
      if(!sizeNotSelected) {
        scrollToElement(storeStockButton);
      }
      this.triggerNewrelicEvent('check-in-store-clicked')
    }
  }

  render(){
    const { actions } = this.state;
    return (<div className={'oos-carousel'}>
      <div className={'oos-carousel__header'}>Out of stock online</div>
      <div className={'oos-carousel__container'}>
        <ul className={'oos-carousel__list'}>
          { actions.map(action => {
            return <li className={'oos-carousel__item'}><a className={'oos-carousel__link'} onClick={()=>action.onClick()}>{action.name}</a></li>
          })}
        </ul>
      </div>
    </div>);
  }
}
